
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bylines/[id]",
      function () {
        return require("private-next-pages/bylines/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bylines/[id]"])
      });
    }
  